export enum ITeamRole {
	ADMIN = 'Admin',
	STANDART = 'Standart',
	OWNER = 'Owner',
	MEMBER = 'Member',
}

export enum ITeamActivity {
	ADMIN = 'Admin',
	STANDART = 'Standart ',
	OWNER = 'Owner',
}
